import * as yup from 'yup';

const numberValidation = yup
  .string()
  .nullable()
  .required();

const stringValidation = yup
  .string()
  .nullable()
  .required();

export const ageValidation = yup.object().shape({
  CurrentAge: numberValidation,
});

export const householdIncomeValidation = yup.object().shape({
  HouseholdIncome: stringValidation,
});

export const monthlyExpenseValidation = yup.object().shape({
  MonthlyExpense: stringValidation,
});

export const monthlySavingsValidation = yup.object().shape({
  MonthlyRetirementSavings: stringValidation,
});

export const savedSoFarValidation = yup.object().shape({
  TotalRetirementSavings: stringValidation,
});

export const fullForm = yup.object().shape({
  CurrentAge: numberValidation,
  HouseholdIncome: stringValidation,
  MonthlyExpense: stringValidation,
  MonthlyRetirementSavings: stringValidation,
  TotalRetirementSavings: stringValidation,
});

export const contactFormValidation = yup.object().shape({
  Name: stringValidation,
  Email: stringValidation,
});